import React from 'react';
import { Document, Page, View, Image } from '@react-pdf/renderer';
import PdfTab from './PdfTab';
import logo from './AssistPoint_Logo.png';

const styles = {
    page: { paddingTop: 35, paddingBottom: 35, paddingHorizontal: 35 }
}

const GenericPdf = props => {
    const { form, tabs } = props;

    return <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <View>
                    <Image src={logo} size='small' style={{ width: 200 }} />
                </View>

                {tabs.map(tab =>
                    <PdfTab
                        key={tab.key}
                        name={tab.name}
                        sections={tab.sections}
                        form={form}
                    />
                )}
            </View>
        </Page>
    </Document>
}

export default GenericPdf;
